import { render, staticRenderFns } from "./JwJiaocaiLogList.vue?vue&type=template&id=5f0604d6"
import script from "./JwJiaocaiLogList.vue?vue&type=script&lang=js"
export * from "./JwJiaocaiLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports